import { RootState } from '../../interfaces/rootState';

export const ApiCacheSelector = (state: RootState) => state.apiCache;
